var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 3.29289C1.31658 2.90237 0.683417 2.90237 0.292893 3.29289C-0.0976311 3.68342 -0.0976311 4.31658 0.292893 4.70711L1.70711 3.29289ZM4 7L3.29289 7.70711C3.68342 8.09763 4.31658 8.09763 4.70711 7.70711L4 7ZM10.7071 1.70711C11.0976 1.31658 11.0976 0.683417 10.7071 0.292893C10.3166 -0.0976311 9.68342 -0.0976311 9.29289 0.292893L10.7071 1.70711ZM0.292893 4.70711L3.29289 7.70711L4.70711 6.29289L1.70711 3.29289L0.292893 4.70711ZM4.70711 7.70711L10.7071 1.70711L9.29289 0.292893L3.29289 6.29289L4.70711 7.70711Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6a0a947561c8920dd723edf1dfcf9cc3.svg";
export { ForwardRef as ReactComponent };